import React from "react";
import VisNetwork from '../components/visualizer-tool/VisJSNetwork';
import {useLocation} from 'react-router-dom';
import "../pages/css/structureeditor.css";


export default function StructureEditor() {
    const location = useLocation();
    const antigenStructure= location.state||"";

    return (
        <div>
            <div className="se container">
                <VisNetwork dbAntigenStructure={antigenStructure}/>          
            </div>
        </div>
    )
}